import { memo, lazy, Suspense } from 'react';

import { Portal } from 'react-portal';
import { LazyMotion, domAnimation, m } from 'framer-motion';

import useAnimatedReactions from './useAnimatedReactions';

import './animatedReactions.scss';

// 1. Lazy-load Lottie so it only downloads when used
const Lottie = lazy(() => import('lottie-react'));

const AnimatedReactions = ({ rootElement, isPip = false }: { rootElement?: HTMLElement; isPip?: boolean }) => {
  const { reactionAnimations, currentPeer, isMobile } = useAnimatedReactions(isPip);

  return (
    <Portal node={rootElement}>
      {/* 2. Wrap all motion calls in LazyMotion with only DOM animators */}
      <LazyMotion features={domAnimation}>
        <div className={`animated-reactions ${isPip ? 'animated-reactions--pip' : ''}`}>
          {reactionAnimations.map((reaction) => {
            if (!reaction) return null;
            const { side, xPosition, sidePosition, animationData, user, id, emoji } = reaction;

            return (
              <m.div
                key={id}
                id={`main-screen-emoji_${emoji}`}
                initial={{ opacity: 1, y: 0, scale: 1 }}
                animate={{
                  opacity: [1, 1, 0],
                  y: [-150, -600],
                  x: isMobile ? [xPosition, xPosition * 0.75] : [xPosition, xPosition * 0.5, xPosition * 0.25],
                  scale: [1, 1, 1],
                }}
                transition={{ duration: 5, ease: 'easeOut' }}
                className="animated-reactions__reaction"
                style={{ [side]: sidePosition }}
              >
                {/* 3. Suspense around Lottie */}
                <Suspense fallback={<div style={{ width: 40, height: 40 }} />}>
                  <Lottie animationData={animationData} style={{ width: 40, height: 40 }} />
                </Suspense>
                <div className="animated-reactions__username">
                  {currentPeer?.peer_info.peer_name === user ? 'You' : user}
                </div>
              </m.div>
            );
          })}
        </div>
      </LazyMotion>
    </Portal>
  );
};

export default memo(AnimatedReactions);
